<script setup lang="ts">
import { useDisplay } from 'vuetify'
import CareersMeetingsImg from '@images/dashboard/careers-meetings.png'

const { smAndDown } = useDisplay()
</script>

<template>
  <VCard class="elevation-5 flex-grow-1">
    <VRow
      no-gutters
      class="h-100"
    >
      <VCol
        cols="3"
        sm="6"
      >
        <div class="bg-image__stretch-to-right">
          <VImg
            :src="CareersMeetingsImg"
            height="100%"
            min-height="250"
            position="right top"
            cover
          />
        </div>
      </VCol>
      <VCol
        cols="9"
        sm="6"
        class="pa-4 d-flex flex-column justify-space-between"
      >
        <div class="d-flex flex-fill">
          <div class="d-flex flex-column justify-center">
            <h4 class="mt-3">
              {{ $t('pages.dashboard.interviewing_card_header') }}
            </h4>
            <p class="text-body-2 my-3">
              {{ $t('pages.dashboard.interviewing_card_text') }}
            </p>
          </div>
        </div>
        <div class="text-right">
          <VBtn
            :to="{ name: 'interviews.request.list' }"
            class="submit-btn"
            :class="smAndDown ? 'text-small text-body-2' : ''"
            prepend-icon="mdi-calendar-month"
            tonal
            rounded="xl"
          >
            {{ $t('pages.dashboard.interviewing_card_btn') }}
          </VBtn>
        </div>
      </VCol>
    </VRow>
  </VCard>
</template>

<style lang="scss" scoped>
.bg-image__stretch-to-right {
  width: calc(100% + 40px);
  height: 100%;
}
</style>
